import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Store as StoreIcon } from "lucide-react";
import { Sidebar } from "./Sidebar";
import { MobileTabBar } from "./MobileTabBar";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-dvh w-full bg-background">
      {/* Desktop / tablet sidebar — hidden on phones (replaced by bottom tab bar) */}
      <div className="hidden md:flex">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      </div>

      <main className="flex-1 min-w-0 flex flex-col">
        {/* Compact mobile top bar — branding only, no navigation drawer */}
        <header className="md:hidden sticky top-0 z-30 flex items-center gap-2 h-12 px-3 border-b border-border/60 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/70 pt-safe">
          <div className="h-7 w-7 rounded-md bg-gradient-primary flex items-center justify-center shadow-glow shrink-0">
            <StoreIcon className="h-3.5 w-3.5 text-primary-foreground" />
          </div>
          <div className="leading-tight min-w-0">
            <div className="text-sm font-semibold text-foreground truncate">
              StoreLedger
            </div>
            <div className="text-[10px] text-muted-foreground tracking-wider uppercase">
              Pro
            </div>
          </div>
        </header>

        <div className="px-3 sm:px-4 md:px-8 py-4 md:py-8 w-full min-w-0 max-w-[1600px] mx-auto animate-fade-in pb-tabbar">
          <Outlet />
        </div>
      </main>

      <MobileTabBar />
    </div>
  );
}
